import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Switch, Route, useHistory } from 'react-router-dom';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

import { notification } from 'antd';

import { stripeApiKey } from './config';
import { init, logOut, selectLoggedIn } from './features/auth/authSlice';
import { fetchProfile, selectError} from './features/profile/profileSlice';

import { Auth } from './features/auth/Auth';

import { Dashboard } from './containers/dashboard';
import { ApiUsage } from './containers/api-usage'
import { ApiLookup } from './containers/api-lookup';
import { Billing, Settings } from './containers/account';
import { Documentation } from './containers/documentation';
import { Admin } from './containers/admin';
import { Layout } from '@builty/components/Layout';
import { Nav } from '@builty/components/Nav';
import { Header } from '@builty/components/Header';
import './App.scss';
import { ApproveUser } from './containers/approve-user';
import {ResetPassoword} from './containers/reset-password'
import S3Browser from './features/s3-browser/index'
import { ConfirmEmail } from './containers/confirm-email'
const stripe = loadStripe(stripeApiKey);

function App() {
  const dispatch = useDispatch();
  const history = useHistory();

  const [ isMobileMenuActive, setMobileManuActive ] = useState(false);
  const [ loginVisible, setLoginVisible ] = useState(false); 

  const loggedIn = useSelector(selectLoggedIn);
  const profileError = useSelector(selectError);

  useEffect(() => {
    dispatch(init());
  }, [dispatch]);

  useEffect(() => {
    if (loggedIn) {
      dispatch(fetchProfile());
    }
  }, [dispatch, loggedIn]);

  useEffect(() => {
    if (loggedIn && loginVisible) {
      setLoginVisible(false);
    }
  }, [dispatch, loggedIn, loginVisible, setLoginVisible]);

  useEffect(() => {
    if (profileError) {
      const authError = profileError.status === 401 || profileError.status === 422;
      notification.error({
        message: authError ? "Please log in again" : "Failed to load user profile; please try again later",
        placement: "top",
      });
      if (authError) {
        dispatch(logOut());
        history.push("/");
      }
    }
  }, [dispatch, history, profileError]);

  const onLogin = () => {
    if (!loggedIn) {
      setLoginVisible(true);
    }
  };

  const onLogOut = () => {
    dispatch(logOut());
    history.push("/");
  };

  const onCancel = () => {
    setLoginVisible(false);
  };

  return (
    <Elements stripe={ stripe }>
      <Layout>
        <Layout.Sidebar>
          <Nav
            isOpen={isMobileMenuActive}
            onClose={() => setMobileManuActive(false)}
            isLoggedIn={loggedIn}
            onLogin={onLogin}
            onLogOut={onLogOut}
          />
        </Layout.Sidebar>
        <Layout.Main>
          <Header
            isNavActive={isMobileMenuActive}
            toggleNav={() => setMobileManuActive(state => !state)}
          />
          <Switch>
            <Route path="/" exact>
              <Dashboard onLogin={ onLogin } />
            </Route>
            <Route path="/permit-lookup" exact>
              <ApiLookup isLoggedIn={loggedIn} onLogin={onLogin} />
            </Route>
            <Route path="/api-usage" exact>
              <ApiUsage />
            </Route>
            <Route path="/billing" exact>
              <Billing />
            </Route>
            <Route path="/settings" exact>
              <Settings />
            </Route>
            <Route path="/documentation" exact>
              <Documentation isLoggedIn={loggedIn} onLogin={onLogin} />
            </Route>
            <Route path="/s3-admin" exact>
              <Admin />
            </Route>
            <Route path="/approve-user" exact>
              <ApproveUser />
            </Route>
            <Route path="/reset-password" exact>
              <ResetPassoword />
            </Route>
            <Route path="/s3-browser" exact>
              <S3Browser />
            </Route>
            <Route path="/s3-browser/*" >
              <S3Browser />
            </Route>
            <Route path="/confirm-email" exact>
              <ConfirmEmail />
            </Route>
          </Switch>
        </Layout.Main>
      </Layout>

      <Route path="/">
        <Auth
          isVisible={loginVisible}
          onCancel={onCancel}
          isLoggedIn={loggedIn}
        />
      </Route>
    </Elements>
  );
}

export default App;
